<template>
  <v-card class="pa-3">
    <v-container>
      <v-row justify="start">
        <v-col cols="12" sm="6">
          <div v-if="data.employeeNameTha">
            {{ data[`employeeName${$lang}`] }}
          </div>
          <div>
            เขียนเมื่อวันที่
            {{ $dateFormatByLang($dateFormat(data.reqDate, {}, 'DD/MM/YYYY')) }}
          </div>
          <div v-if="data.reasonID != 2">
            เหตุผล : <span class="grey--text">{{ data.seasonText }}</span>
          </div>
          <div v-else>
            <div>
              เหตุผล : <span class="grey--text">{{ data.seasonText }}</span> ไป
              :
              <span class="grey--text">{{ data.country }}</span>
            </div>
            <div>
              ตั้งแต่วันที่ :
              <span class="grey--text">{{ data.startDate }}</span> ถึงวันที่ :
              <span class="grey--text">{{ data.endDate }}</span> จำนวน :
              <span class="grey--text">{{ dateFormat }} วัน</span>
            </div>
          </div>
          <div>
            {{ data.language === 'Tha' ? 'ภาษาไทย' : 'ภาษาอังกฤษ' }} :
            <span class="grey--text">จำนวน {{ data.copy }} ฉบับ</span>
          </div>
        </v-col>
        <v-col cols="auto">
          <v-chip :color="data.color" class="white--text">{{
            data.status
          }}</v-chip>
        </v-col>
        <v-col class="text-end">
          <v-btn
            @click="
              $router.push('/ReqCer/info/' + data.tbReqFormId + '/' + type)
            "
            elevation="0"
            color="primary"
          >
            ดูข้อมูล
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: ['data', 'type'],
  computed: {
    dateFormat() {
      return this.$dateDiff(
        this.$dateFormat(this.data.endDate, {}, 'DD/MM/YYYY'),
        this.$dateFormat(this.data.startDate, {}, 'DD/MM/YYYY')
      )
    }
  },
  methods: {}
}
</script>
